import { useCallback, useEffect, useState } from "react";
import ExtraPayService from "../../../../../../service/ExtraPayService";
import { EXTRAPAY_SUCCESS_CODE } from "../constants";
import { mapCycleConversion, sortConversionsDesc } from "../mapConversions";

const useExtrapayConversions = () => {
  const [conversions, setConversions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const reload = useCallback(async () => {
    const token = localStorage.getItem("__extraconomy_token");
    const username = localStorage.getItem("__extraconomy_username");
    const service = new ExtraPayService(token);
    setIsLoading(true);
    setHasError(false);

    try {
      const response = await service.getConversionsByUser(username);
      if (response?.messageCode !== EXTRAPAY_SUCCESS_CODE) {
        setHasError(true);
        setConversions([]);
        return { ok: false, code: response?.messageCode };
      }
      const mapped = sortConversionsDesc(
        (Array.isArray(response.result) ? response.result : []).map(mapCycleConversion),
      );
      setConversions(mapped);
      return { ok: true };
    } catch (error) {
      setHasError(true);
      setConversions([]);
      return { ok: false };
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { conversions, isLoading, hasError, reload };
};

export default useExtrapayConversions;
